module.exports = __webpack_public_path__ + "img/emoji-sparkles-2x.f392dc88.png";